import { render, staticRenderFns } from "./SocialsPopover.vue?vue&type=template&id=881fe8ca&scoped=true&"
import script from "./SocialsPopover.vue?vue&type=script&lang=js&"
export * from "./SocialsPopover.vue?vue&type=script&lang=js&"
import style0 from "./SocialsPopover.vue?vue&type=style&index=0&id=881fe8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881fe8ca",
  null
  
)

export default component.exports